import service from '@/utils/request'
import { requestService as encryptionService } from '@/utils/axios-encryption'
import service2 from '@/utils/axios-v2'

const baseURL = process.env.VUE_APP_TP_URL || process.env.VUE_APP_URL;
function getProtalToken() {
  return JSON.parse(localStorage.getItem("TP_PORTAL_TOKEN_V2"));
}
/**
 * 获取poi搜索结果
 *
 * @export
 * @param {*} data
 * @returns
 */
export function getRecommendPoi(data) {
  return encryptionService({
    url: '/fleet/place/title/v2',
    method: 'post',
    data: data
  })
}

/**
 * 获取address建议结果
 */
export function getAddressAutosuggest(params) {
  return service({
    baseURL,
    url: '/tp/place/autocomplete/v2',
    method: 'get',
    timeout: 10000,
    params
  })
}
/**
 * 获取address建议结果 New
 */
export function getAddressList(params) {
  return service({
    baseURL,
    url: '/fleet/map/autocomplete',
    method: 'get',
    timeout: 10000,
    params,
    headers: {
      'portal-token': getProtalToken(),
      'client': 'Truckerpath_Command/5.8.0'
    },
  })
}
/**
 * 获取address搜索结果
 */
export function getAddressSearch(params) {
  return service({
    baseURL,
    url: '/tp/place/autocomplete/search',
    method: 'get',
    timeout: 10000,
    params
  })
}

export function getAddressDetail(params) {
  return service({
    baseURL,
    url: '/tp/places/here/detail',
    method: 'get',
    params
  })
}

export function getAddressDetailV3(data) {
  return service({
    baseURL,
    url: '/tp/places/tripartite/detail',
    method: 'post',
    data: { param: data },
    headers: {
      'tp-interface': true
    }
  })
}

export function getPoiDetail(poiId) {
  return service({
    url: `/fleet/place/${poiId}`,
    method: 'get'
  })
}

export function getPoiDetailV2(poiId) {
  return encryptionService({
    url: '/fleet/place/detail',
    method: 'post',
    data: { id: poiId }
  })
}

export function getFacilityDetail(facilityId) {
  return encryptionService({
    baseURL,
    url: '/tp/facility/find/detail/info/v3',
    method: 'post',
    data: { isFacility: true, facilityId }
  })
}


export function getPointAutosuggest(params, data) {
  return service2({
    baseURL,
    url: '/fleet/place/autocomplete',
    method: 'post',
    params,
    data,
    headers: {
      'client': 'Truckerpath_Command/5.8.0'
    }
  })
}

export function addSearchReturn(data) {
  return service2({
    baseURL,
    url: '/tp/places/search/return',
    method: 'post',
    data,
    headers: {
      'tp-interface': true
    },
    isNotPrompt: true
  })
}